module.exports = __webpack_public_path__ + "img/contratoIPScomprimido.65b9389e.jpg";